
class ProductWithMarqueeImage {
  constructor(sectionEl) {
    this.root = sectionEl;
    this.viewport = sectionEl.querySelector('.image-marquee__viewport');
    this.contents = sectionEl.querySelectorAll('.image-marquee__content');
    this.onResize = this.syncContentWidths.bind(this);
    this.onMouseEnter = this.pause.bind(this);
    this.onMouseLeave = this.resume.bind(this);
  }

  init() {
    if (!this.viewport || !this.contents.length) return;
    
    // Pause/resume on hover
    this.viewport.addEventListener('mouseenter', this.onMouseEnter);
    this.viewport.addEventListener('mouseleave', this.onMouseLeave);
    
    // Ensure seamless animation by syncing content widths
    this.syncContentWidths();
    window.addEventListener('resize', this.onResize, { passive: true });
  }

  syncContentWidths() {
    if (this.contents.length < 2) return;
    
    // Make sure both content groups have the same computed width
    const firstContent = this.contents[0];
    const secondContent = this.contents[1];
    
    // Reset any inline styles
    firstContent.style.minWidth = '';
    secondContent.style.minWidth = '';
    
    // Get natural widths
    const width1 = firstContent.scrollWidth;
    const width2 = secondContent.scrollWidth;
    const maxWidth = Math.max(width1, width2);
    
    // Apply max width to both to ensure they're identical
    firstContent.style.minWidth = maxWidth + 'px';
    secondContent.style.minWidth = maxWidth + 'px';
  }

  pause() {
    this.contents.forEach(content => {
      content.style.animationPlayState = 'paused';
    });
  }

  resume() {
    this.contents.forEach(content => {
      content.style.animationPlayState = 'running';
    });
  }

  destroy() {
    window.removeEventListener('resize', this.onResize);
    if (this.viewport) {
      this.viewport.removeEventListener('mouseenter', this.onMouseEnter);
      this.viewport.removeEventListener('mouseleave', this.onMouseLeave);
    }
  }
}

function initAll() {
  document.querySelectorAll('.image-marquee').forEach((sectionEl) => {
    const instance = new ProductWithMarqueeImage(sectionEl);
    instance.init();
    sectionEl.__marqueeInstance = instance;
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

document.addEventListener('shopify:section:load', (event) => {
  const sectionEl = event.target.querySelector('.image-marquee');
  if (sectionEl) {
    const instance = new ProductWithMarqueeImage(sectionEl);
    instance.init();
    sectionEl.__marqueeInstance = instance;
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  const sectionEl = event.target.querySelector('.image-marquee');
  if (sectionEl && sectionEl.__marqueeInstance) {
    sectionEl.__marqueeInstance.destroy();
    delete sectionEl.__marqueeInstance;
  }
});
